import React, { useState } from 'react'
import { useOpenTaskCount } from '../../pages/tasks/common/task-common'
import TaskDrawer from '../../pages/tasks/drawer/task-drawer'
import { TasksIcon } from './icons'

const KarteraTasks = () => {
    const [open, setOpen] = useState(false)
    const { count, setCount } = useOpenTaskCount()

    return (
        <>
            <button
                type="button"
                aria-label={count ? `Tareas, ${count} pendientes` : 'Tareas'}
                title="Tareas"
                aria-haspopup="dialog"
                aria-expanded={open}
                onClick={() => setOpen(true)}
                className={`flex h-11 shrink-0 cursor-pointer items-center gap-2 rounded-xl border-0 px-2.5 text-sm font-semibold text-k-ink-2 md:px-3 ${open ? 'bg-k-accent-soft text-k-ink' : 'bg-transparent hover:bg-k-hover hover:text-k-ink'}`}
            >
                <TasksIcon />
                <span className="hidden md:inline">Tareas</span>
                {count > 0 && (
                    <span className="flex h-5 min-w-5 items-center justify-center rounded-full bg-brand-indigo px-1.5 text-[11px] font-extrabold !text-white">
                        {count > 99 ? '99+' : count}
                    </span>
                )}
            </button>
            <TaskDrawer open={open} onClose={() => setOpen(false)} onCountChange={setCount} />
        </>
    )
}

export default KarteraTasks
